import React from "react";
import { Dropdown, Badge, Space, List, Typography } from "antd";
import { FiBell } from "react-icons/fi";

import { Link } from "react-router-dom";

// Define DropdownNotification component
const DropdownNotification: React.FC = () => {
  // Notification data for the list
  const notificationData = [
    {
      id: 1,
      title: "Edit your information in a swipe",
      description: "Sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim.",
      date: "12 May, 2025"
    },
    {
      id: 2,
      title: "It is a long established fact",
      description: "that a reader will be distracted by the readable.",
      date: "24 Feb, 2025"
    },
    {
      id: 3,
      title: "There are many variations",
      description: "of passages of Lorem Ipsum available, but the majority have suffered",
      date: "04 Jan, 2025"
    },
    {
      id: 4,
      title: "There are many variations",
      description: "of passages of Lorem Ipsum available, but the majority have suffered",
      date: "01 Dec, 2024"
    },
    {
      id: 5,
      title: "There are many variations",
      description: "of passages of Lorem Ipsum available, but the majority have suffered",
      date: "01 Dec, 2024"
    },
    {
      id: 6,
      title: "There are many variations",
      description: "of passages of Lorem Ipsum available, but the majority have suffered",
      date: "01 Dec, 2024"
    }
  ];

  return (
    <li className="relative">
      <Dropdown
        placement="bottomRight"
        trigger={["click"]}
        dropdownRender={() => (
          <div 
            style={{ 
              width: "320px", 
              boxShadow: "0 3px 6px rgba(0,0,0,0.16)",
              borderRadius: "8px",
              marginTop:"18px",
              border:"1px solid #e5e7eb",
              backgroundColor: "white"
            }}
          >
            <div className="px-3 py-2 border-b border-gray-200 font-medium">Notification</div>
            <div className="max-h-80 custom-scroll overflow-y-auto">
              <List
                dataSource={notificationData}
                renderItem={(item) => (
                  <List.Item style={{ padding: 0 }}>
                    <Link to="#" className="w-full px-4 py-3 hover:bg-gray-100">
                      <div className="flex flex-col gap-2">
                        <Typography.Text strong className="text-sm" style={{ color: "#6c5ffc" }}>{item.title}</Typography.Text>
                        <Typography.Text className="text-sm">{item.description}</Typography.Text>
                        <Typography.Text className="text-xs text-gray-500">{item.date}</Typography.Text>
                      </div>
                    </Link>
                  </List.Item>
                )}
              />
            </div>
          </div>
        )}
      >
        <Space className="relative flex text-lg cursor-pointer">
          <div className="relative">
          <FiBell  size={20} color="#6c5ffc" />
            <span className="absolute bottom-[13px] right-0 z-1 h-2 w-2 rounded-full bg-red-600 inline">
              <span className="absolute -z-1 left-0 inline-flex h-full w-full animate-ping rounded-full bg-red-600 opacity-75"></span>
            </span>
          </div>
        </Space>
      </Dropdown>
    </li>
  );
};

export default DropdownNotification;
